import { TableView, MailRowDataPropertyGetter } from 'owa-mail-list-store';
import { TriageContext } from 'owa-mail-actions/lib/triage/TriageContext';
import { ActionType } from 'owa-mail-actions/lib/triage/userMailInteractionAction';

export default function getUserInteractionContext(
    rowKeys: string[],
    tableView: TableView,
    actionType: ActionType,
    folderId?: string
): TriageContext {
    if (rowKeys.length != 1) {
        return {
            rowKeys,
        };
    }

    const rowKey = rowKeys[0];
    const uniqueSendersFromMailData = MailRowDataPropertyGetter.getUniqueSenders(rowKey, tableView);
    const mailbox = MailRowDataPropertyGetter.getLastSenderMailbox(rowKey, tableView);
    const triageContext = {
        uniqueSenders: uniqueSendersFromMailData,
        lastSenderMailbox: mailbox,
        folderId: folderId,
        rowKeys: [rowKey],
    };

    return triageContext;
}
